var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonuses"
  }, [_c('div', {
    staticClass: "bonuses__balance"
  }, [_c('p', {
    staticClass: "bonuses__balance-title mb-8"
  }, [_vm._v("\n      Ваш баланс\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "bonuses__balance-count"
  }, [_vm._v("\n      " + _vm._s(_vm.formatPrice(_vm.balance)) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "bonuses__write"
  }, [_vm.allowToSpend ? _c('p', {
    staticClass: "bonuses__write-title mb-8"
  }, [_vm._v("\n      Списать " + _vm._s(_vm.allowToSpend) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bonuses__write-toggle"
  }, [_c('ToggleSwitch', {
    attrs: {
      "disabled": _vm.disabled,
      "model-value": _vm.modelValue
    },
    on: {
      "update:model-value": function ($event) {
        return _vm.emit('update:model-value', $event);
      }
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }